module.exports = __webpack_public_path__ + "static/piramida-e7a16ff62624767d5d34ad0511389bd3.png";